import { code } from "@streamdown/code"
import { mermaid } from "@streamdown/mermaid"
import type { ComponentProps } from "react"
import type { Streamdown } from "streamdown"

/**
 * streamdown 2 moved code highlighting and Mermaid into opt-in plugins and
 * changed a few defaults (a link-confirmation modal, code line numbers, a
 * 300px table height cap). These props keep the 1.x rendering the chat UI was
 * built on; callers can still override any of them. Module-level so the
 * memoized Streamdown sees stable references.
 */
export const streamdownDefaults = {
  plugins: { code, mermaid },
  // The app is dark without a `.dark` class, so streamdown's `dark:` token
  // colours never apply and the default [github-light, github-dark] pair
  // painted light-theme tokens (near-black identifiers) on the dark code
  // background. Use the dark theme for both slots.
  shikiTheme: ["github-dark", "github-dark"],
  linkSafety: { enabled: false },
  lineNumbers: false,
  codeBlockMaxHeight: "none",
  tableMaxHeight: "none",
} satisfies Partial<ComponentProps<typeof Streamdown>>
